import { Directive, ElementRef, Input } from "@angular/core";
import { Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { DeckBaseComponent } from "./deck-base.component";
import { DeckLayerComponent } from "./deck-layer.component";
import { DeckMultiRowComponent } from "./deck-multi-row.component";
import { DeckGroupComponent } from "./group/deck-group.component";
import { formatCurrency } from "@ponder-shared/utils/numberFormatter";

@Directive()
export class DeckRowComponent {
    @Input({ required: true }) public isOwnDeck!: boolean;
    @Input({ required: true }) public deck!: Deck;
    @Input({ required: true }) public deckComponent!: DeckBaseComponent;
    @Input({ required: true }) public deckLayerComponent!: DeckLayerComponent;
    @Input({ required: true }) public deckGroupComponent!: DeckGroupComponent;
    @Input({ required: true }) public deckMultiRowComponent!: DeckMultiRowComponent;
    @Input({ required: true }) public deckCard!: DeckCard;

    public constructor(public elementRef: ElementRef) {
        
    }

    public ngOnInit(): void {
        this.deckMultiRowComponent.registerRowComponent(this);
    }

    public ngOnDestroy(): void {
        this.deckMultiRowComponent.unregisterRowComponent(this);
    }

    public getRowValue(): string {
        var value = (this.deckCard.count * this.deckCard.card.price.normalUSD) + (this.deckCard.specialCount * this.deckCard.card.price.specialUSD);
        
        if (value > 100) {
            return "$" + value.toFixed(0);
        } else {
            return formatCurrency(value);
        }
    }
}